import { render, staticRenderFns } from "./FormViewerHeader.vue?vue&type=template&id=3393e7b4&"
import script from "./FormViewerHeader.vue?vue&type=script&lang=js&"
export * from "./FormViewerHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports